import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

type ChangeCategoryMarketShopInventoryItemRequest = {
  id: number
  categoryId?: number
  buildingId: number
}

type BulkActionResponse = {
  affected: number
  failed: number[]
}

const changeCategoryMarketShopInventoryItem = async (
  data: ChangeCategoryMarketShopInventoryItemRequest,
): Promise<BulkActionResponse> => {
  const response = await authAPI.post<BulkActionResponse>('/market-shop/products/bulk', {
    action: 'changeCategory',
    buildingId: data.buildingId,
    categoryId: data.categoryId,
    ids: [data.id],
  })
  return response.data
}

export const useChangeCategoryMarketShopInventoryItem = () => {
  return useMutation({
    mutationFn: changeCategoryMarketShopInventoryItem,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: async ({ affected }) => {
      await resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
      if (affected > 0) {
        toastFactory.success('Category changed successfully')
      } else {
        toastFactory.error('Failed to update category')
      }
    },
  })
}
